import { User } from "types";

export function isGUEST(userData?: User | null): boolean {
  return userData?.config?.access_type === "GUEST";
}
